interface Scripts {
  name: string;
  src: string;
}
export const ScriptStore: Scripts[] = [
  {name: 'goldenrace', src: 'https://virtual.golden-race.net/desktop-v3/default/golden-race-desktop-loader.js'} ,
  {name: 'goldenracemobile', src: 'https://virtual.golden-race.net/mobile-v2/golden-race-mobile-loader.js'}
];



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/script.store.ts